import React from "react";
import { Button, Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

const DownloadCatalog =()=>{
    return(
        <>
        <div className="mt-5 mb-5 d-md-block d-none">
            <Row className="justify-content-center m-1">
            <Col md={6} style={{backgroundImage:"url(./assests/images/Frame84.svg)", 
                height:"337px",
                backgroundSize:"cover"
            }}>

            </Col>
            <Col md={6} style={{backgroundImage:"url(./assests/images/oldFrame83.svg)", 
                height:"337px",
                backgroundSize:"cover"
            }}>
                
                
            </Col>
            
                <Button id="downloadCatalog" className="fw-bold">
                <Link to="https://catalog.eyantra.com/" className="text-black text-decoration-none">Download Catalog
                </Link>
                </Button>
            
            </Row>
        </div>

            {/**Mobile version */}
        <div className="mt-5 mb-5 d-md-none d-block">
            <Row className="justify-content-center m-1">
            <Col md={12} style={{backgroundImage:"url(./assests/images/Frame84.svg)", 
                height:"337px",
                backgroundSize:"cover"
            }}>
                <Link to="https://catalog.eyantra.com/">
             <Button id="downloadCatalog" className="fw-bold d-block mx-auto position-relative">Download Catalog</Button>
             </Link>
            </Col>
            
           
            </Row>
        </div>

        </>
    )
}

export default DownloadCatalog